// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__b8K5E","preloader_global":"Preloader_preloader_global__4CDvj","preloader_inner":"Preloader_preloader_inner__3NLK2"};